import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import { Container, Card, CardBody, CardTitle, Spinner, Button } from 'reactstrap';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { get } from 'helpers/api_helper';

const TrackingStatus = () => {
  const { trackingId } = useParams();
  const [trackingData, setTrackingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrackingData = async () => {
      try {
        const response = await get(`track?_n=${trackingId}`);
        setTrackingData(response);
      } catch (error) {
        console.error('Error fetching tracking data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (trackingId) {
      fetchTrackingData();
    }
  }, [trackingId]);

  const formatDateTime = (date, time) => {
    if (!date || !time) return 'Pending';
    return moment(`${date} ${time}`).format('MMM DD, YYYY hh:mm A');
  };

  const refreshTracking = async () => {
    setLoading(true);
    try {
      const response = await get(`track?_n=${trackingId}`);
      setTrackingData(response);
    } catch (error) {
      console.error('Error fetching tracking data:', error);
    } finally {
      setLoading(false);
    }
  };

  const isValidText = (val) =>
  val && !val.includes('undefined') && val.trim() !== '';

  const getLocationText = (checkpoint) => {
    if (isValidText(checkpoint.location)) {
      return checkpoint.location;
    }

    if (isValidText(checkpoint.place)) {
      return checkpoint.place;
    }

    return 'Location not available';
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Shipments | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <CardTitle tag="h4">Shipment Tracking - {trackingId}</CardTitle>
                <Button 
                  color="primary" 
                  className="btn-sm" 
                  onClick={refreshTracking}
                  disabled={loading}
                >
                  <i className="bx bx-refresh me-1"></i>
                  Refresh
                </Button>
              </div>
              
              {loading ? (
                <div className="text-center p-3">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <div className="mb-3">
                    <strong>Current Status: </strong>
                    <span className="badge bg-soft-info text-info">{trackingData?.mostRecentStatus || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <strong><span className="badge bg-soft-info text-info">{trackingData?.exp_date || 'N/A'}</span>
                    </strong>
                  </div>

                  <div className="activity-feed">
                    {trackingData?.checkpoints?.map((checkpoint, index) => (
                      <div key={index} className="feed-item">
                        <div className="feed-item-list">
                          <div>
                            <h5 className="font-size-15 mt-2">{checkpoint.activity}</h5>
                            <div className="date-time">
                              <i className="bx bx-time-five"></i>
                              {checkpoint.date}
                              {/* {formatDateTime(checkpoint.date, checkpoint.time)} */}
                            </div>
                            <p className="text-muted mt-1 mb-0">
                              <i className="bx bx-map me-1"></i>
                              {getLocationText(checkpoint)}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TrackingStatus;